class DataSourceModel {
  getMappedObject() {
    throw new Error("Not Implemented");
  }
}

export default DataSourceModel;
